import React from 'react';
import clientLogo from '../img/tower/cirro-logo.png';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

export default class Logo extends React.Component {

    constructor() {
        super();
    }

    render() {
        return (
            <>
                <img className={`logo-splash ${isBrowser ? 'desktop' : null}`} src={clientLogo} />
            </>
        )
    }
}
